<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte/internal'
    import { faAngleLeft, faAngleRight, faCheck } from '@fortawesome/free-solid-svg-icons'
    import { faSquare } from '@fortawesome/free-regular-svg-icons'
    import { navigateTo } from 'yrv'
    import Fa from 'svelte-fa'
    import ObStep from './ob-step.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import Popover from '../_common/popover.svelte'
    // Os cadastros abrem aqui dentro, então cada um é a própria tela de configuração — não o
    // roteador que a envolve no menu. Ex.: ScheduleConfigSchedulers, e não Schedulers, que é só
    // a casca com as abas e depende da URL para escolher o que mostrar.
    import ScheduleConfigSchedulers from '../account/schedulers/schedule-config-schedulers.svelte'
    import UserManager from '../account/users/user-manager.svelte'
    import PaymentMethods from '../account/payments/payments.svelte'
    import Services from '../account/services/services.svelte'
    import Referrals from '../account/referrals/referrals.svelte'
    import CompanyManager from '../account/companies/company-manager.svelte'
    import ProvidersManager from '../automacao/providers/providers-manager.svelte'
    const dispatch = createEventDispatcher()

    const feitos = [
        { title: 'Agendas', hint: 'aproveite e configure horários de atendimento', component: ScheduleConfigSchedulers },
        { title: 'Usuários', hint: 'aproveite e configure algumas permissões', component: UserManager },
        { title: 'Meios de pagamento', hint: 'aproveite e configure as taxas', component: PaymentMethods },
        { title: 'Serviços', hint: '', component: Services },
        { title: 'Origens dos clientes', hint: '', component: Referrals },
    ]

    const pendentes = [
        { title: 'Dados da empresa', hint: 'seu cadastro está incompleto', component: CompanyManager },
        { title: 'Provedores de comunicação', hint: 'configure seu primeiro canal de comunicação', component: ProvidersManager },
    ]

    let aberto = null

    function abrir(item) {
        aberto = item
    }

    function fechar() {
        aberto = null
    }

    function showSchedule() {
        navigateTo('/agenda/all')
    }

    function onBack() {
        dispatch('back')
    }

    onMount(async () => {
        await window.flags('onboarding', false, true)
    })
</script>

{#if aberto}
    <Popover title={aberto.title} width="1600px" height="85vh" on:close={fechar}>
        <svelte:component this={aberto.component} />
    </Popover>
{/if}

<ObStep title="Pronto!" label="Você concluiu as configurações básicas para usar o Zandu.">
    <svelte:fragment slot="acts">
        <Zbutton color="secondary" icon={faAngleLeft} label="Voltar" on:click={onBack} />
        <Zbutton color="secondary" icon={faAngleRight} label="Avançar" disabled={true} />
    </svelte:fragment>

    <p>Você pode clicar em qualquer uma das opções abaixo para acessar o cadastro completo.</p>

    <div class="ob-finish_group">Você acabou de configurar:</div>
    {#each feitos as item}
        <button class="ob-finish_row" on:click={() => abrir(item)}>
            <div class="ob-finish_mark is-done"><Fa icon={faCheck} /></div>
            <div class="ob-finish_text">
                <span class="ob-finish_title">{item.title}</span>
                {#if item.hint}
                    <span class="ob-finish_hint">— {item.hint}</span>
                {/if}
            </div>
            <div class="ob-finish_go"><Fa icon={faAngleRight} /></div>
        </button>
    {/each}

    <div class="ob-finish_group">Talvez você queira configurar agora:</div>
    {#each pendentes as item}
        <button class="ob-finish_row" on:click={() => abrir(item)}>
            <div class="ob-finish_mark"><Fa icon={faSquare} /></div>
            <div class="ob-finish_text">
                <span class="ob-finish_title">{item.title}</span>
                {#if item.hint}
                    <span class="ob-finish_hint">— {item.hint}</span>
                {/if}
            </div>
            <div class="ob-finish_go"><Fa icon={faAngleRight} /></div>
        </button>
    {/each}

    <div class="mt-3">
        <Zbutton color="primary" label="Ir para o Zandu" on:click={showSchedule} />
    </div>
</ObStep>

<style>
    .ob-finish_group {
        margin-top: 16px;
        margin-bottom: 4px;
        font-size: 14px;
        opacity: 0.6;
    }

    .ob-finish_row {
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
        max-width: 720px;
        padding: 8px 12px;
        text-align: left;
        font-size: 14px;
        color: inherit;
        background: transparent;
        border: 1px solid #99999925;
        border-radius: 4px;
        margin-bottom: 4px;
        cursor: pointer;
    }

    .ob-finish_row:hover {
        background-color: #ffffff12;
        border-color: #99999950;
    }

    :global(.theme_light) .ob-finish_row:hover {
        background-color: #00000010;
    }

    .ob-finish_mark {
        flex: 0 0 16px;
        opacity: 0.4;
    }

    .ob-finish_mark.is-done {
        color: #2f765a;
        opacity: 1;
    }

    :global(.theme_light) .ob-finish_mark.is-done {
        color: #2f765a;
    }

    .ob-finish_text {
        flex-grow: 1;
    }

    .ob-finish_hint {
        opacity: 0.6;
    }

    /* a seta só aparece no hover: a lista é para ser lida como um resumo, e não como um menu */
    .ob-finish_go {
        flex: 0 0 12px;
        opacity: 0;
    }

    .ob-finish_row:hover .ob-finish_go {
        opacity: 0.6;
    }
</style>
